import { Flex, Text } from "@mantine/core";
import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router";
import DataTable, { Column } from "../../common/Table/DataTable";
import TableDeleteButton from "../../common/Buttons/TableDeleteButton";
import TableEditButton from "../../common/Buttons/TableEditButton";
import { useTableQuery } from "../../../hooks/useTableQuery";
import { useDeleteWithConfirm } from "../../../hooks/useDeleteWithConfirm";
import {
  deleteDepartment,
  getDepartmentsList,
} from "../../../api/departmentApi";
import { useAuth } from "../../../context/AuthContext";

const DepartmentSettingsTable = () => {
  const { refetchDepartmentSelectData } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const table = useTableQuery({ fetcher: getDepartmentsList });

  const onDeleted = useCallback(() => {
    table.refetch();
    refetchDepartmentSelectData();
  }, [table, refetchDepartmentSelectData]);

  const { askDelete, modal } = useDeleteWithConfirm({
    deleteFn: deleteDepartment,
    onDeleted,
    title: "Departmanı Sil",
    text: "Bu departmanı silmek istediğinizden emin misiniz?",
  });

  const columns: Column[] = [
    {
      key: "name",
      header: "Departman İsmi",
      width: "35%",
      render: (row) => (
        <Text fw={400} size="md">
          {row?.name}
        </Text>
      ),
    },
    {
      key: "description",
      header: "Açıklama",
      width: "45%",
      render: (row) => (
        <Text size="md" fw={400} style={{ lineHeight: "1.5", color: "#111827" }}>
          {row?.description || "Açıklama belirtilmemiş."}
        </Text>
      ),
    },
    {
      key: "actions",
      header: "İşlemler",
      width: "20%",
      render: (row) => (
        <Flex gap={6} justify="start">
          <TableEditButton
            onClick={(e: any) => {
              e.stopPropagation();
              navigate(`${location.pathname}/${row?._id}/update`);
            }}
          />
          <TableDeleteButton
            onClick={(e: any) => {
              e.stopPropagation();
              askDelete(row);
            }}
          />
        </Flex>
      ),
    },
  ];

  return (
    <>
      <DataTable
        columns={columns}
        rows={table.rows}
        loading={table.loading}
        emptyText="Henüz departman kaydı yok."
        searchValue={table.search}
        onSearchChange={table.setSearch}
        searchPlaceholder="Departman ara..."
        page={table.page}
        totalPages={table.totalPages}
        onPageChange={table.setPage}
        limit={table.limit}
        onLimitChange={table.setLimit}
      />
      {modal}
    </>
  );
};

export default DepartmentSettingsTable;
